// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1ryve","info":"UpdateTermsInfo_info__1UnO6"};